/** Start een browser-download voor een Blob. */
export function downloadBlob(blob: Blob, bestandsnaam: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = bestandsnaam;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // Geef de browser even de tijd om de download te starten.
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

/** Leest een File als base64 data-url (voor offline opslag van foto's). */
export function bestandNaarDataUrl(bestand: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(reader.error ?? new Error('Bestand kon niet worden gelezen'));
    reader.readAsDataURL(bestand);
  });
}
